import Loadable from '../../components/Loadable';
import { lazy } from 'react';

const CreateBill = Loadable(lazy(() => import('./createbill/CreateBill')));
const BillList = Loadable(lazy(() => import('./createbill/BillList')));
const BillDetails = Loadable(lazy(() => import('./createbill/BillDetails')));
const BillSummary = Loadable(lazy(() => import('./createbill/BillSummary')));
const BillUpdate = Loadable(lazy(() => import('./createbill/BillUpdate')));
const ManagePaid = Loadable(lazy(() => import('./paidbilty/ManagePaidBilty')));
const Outstanding = Loadable(lazy(() => import('./Outstanding')));

const billRoutes = [
  { path: '/bill', element: <CreateBill /> },
  { path: '/billlist', element: <BillList /> },
  { path: '/billdetails', element: <BillDetails /> },
  { path: '/billupdate', element: <BillUpdate /> },
  { path: '/paidbilty', element: <ManagePaid /> },
  { path: '/outstanding', element: <Outstanding /> },
  { path: '/billsummary', element: <BillSummary /> },
];

export default billRoutes;
